import LRU from 'lru-cache';
import * as R from 'ramda';

export class actionLogger {
  constructor(size) {
    this.actions = new LRU(size);
  }

  middleware = store => next => action => {
    this.actions.set(new Date().getTime(), action);
    return next(action);
  };

  retrieve = () => {
    let values = [];
    this.actions.rforEach((v, k) => {
      values.push(R.assoc('timestamp', k, v));
    }, this);
    return values;
  };
}



// WEBPACK FOOTER //
// ./src/redux-middleware.js